import { Insights } from './insights';
import { MockInsights } from './mock-insights';

const InsightsLoader = (isMock, include = true) => {
    if (!include) return {};

    return isMock ? MockInsights : Insights;
};

export { InsightsLoader };
